import LegalPage from "@/components/LegalPage";
import { TERMS_MARKDOWN } from "@/legal/terms";

export default function Terms() {
  return <LegalPage content={TERMS_MARKDOWN} testId="page-terms" />;
}
